import React, { useState } from 'react';
import '../CSS/faq.css'; 

export default function FAQ() {
  const [openQuestion, setOpenQuestion] = useState(null);

  const toggleAccordion = (id) => {
    setOpenQuestion(openQuestion === id ? null : id);
  };

  const faqData = [
    {
      category: "Subscription",
      items: [
        {
          id: "question1",
          question: "What is a cycle subscription?",
          answer: "Select a cycle of your choice and pay rent to use it. You own the cycle for the duration you subscribe it for."
        },
        {
          id: "question2",
          question: "How can I subscribe?",
          answer: (
            <p>
              Step 1 - Choose a cycle (Add accessories) <br />
              Step 2 - Select duration <br />
              Step 3 - Make payment
            </p>
          )
        },
        {
          id: "question3",
          question: "What is included in the subscription amount?",
          answer: "Your subscription amount includes a cycle, a lock, a bottle holder and all taxes."
        }
      ]
    },
    {
      category: "Booking & Payment",
      items: [
        {
          id: "question4",
          question: "What documents will be required for booking?",
          answer: (
            <p>
              1. Any ID Proof - Aadhaar Card / PAN Card / Driving License. <br /> 
              2. Any Current Address Proof.
            </p>
          )
        },
        {
          id: "question5",
          question: "Is there a security deposit for booking? When will I get it back?",
          answer: "Yes. You need to pay Rs.1000 - Rs.3000 (depending on the category of cycle) as a refundable security deposit. It will be refunded within 12 hours of completion of your subscription."
        },
        {
          id: "question7",
          question: "How do I book a cycle?",
          answer: "Complete the payment and share the required documents mentioned above."
        },
        {
          id: "question8",
          question: "What are the payment options available?",
          answer: "You can pay by Gpay / Paytm / Bank transfer / UPI / Debit card / Credit card."
        },
        {
          id: "question9",
          question: "Is there a late fee policy for overdue payments?",
          answer: "Yes, a late fee of Rs.50 per day will be charged for payments made after the due date. Please ensure timely payments to avoid these charges."
        }
      ]
    },
    {
      category: "Delivery & Pick Up",
      items: [
        {
          id: "question10",
          question: "Is home delivery available?",
          answer: "Yes. We home deliver and pick up from your place at an amount of Rs.299 - Rs.899 (depending on your location) OR you can pick up the cycle from our store as well."
        },
        {
          id: "question11",
          question: "Do I have to be present during delivery?",
          answer: "Yes, you need to be present at the time of delivery to collect the cycle. We expect you to check the cycle on delivery and inform us of any problems at the same time."
        },
        {
          id: "question12",
          question: "Can I select the date and time of delivery?",
          answer: "Yes. You can choose a preferred date & time when you want your cycle to be delivered."
        }
      ]
    },
    {
      category: "Maintenance & Security",
      items: [
        {
          id: "question13",
          question: "Who is responsible for maintaining the cycle?",
          answer: "We provide you with a perfectly maintained cycle on delivery. After which it is your responsibility to take care of it. We expect you to return the cycle in the same condition that it was delivered to you."
        },
        {
          id: "question14",
          question: "Who is responsible in case of any damages to the cycle?",
          answer: "We expect you to take good care of the cycle. Wear and tear due to usage of the cycle is normal. In case of any physical damage to the cycle or any part, you will be charged for the same."
        },
        {
          id: "question15",
          question: "What do I do if I meet with an accident?",
          answer: "The very first thing is to make yourself safe. Please contact us immediately at +91 9820760684 and we will guide you with the appropriate steps."
        },
        {
          id: "question16",
          question: "Who is responsible for the security of the cycle?",
          answer: "Every Twin Tring cycle comes with a lock to secure it. The subscriber is solely responsible for the cycle’s security and safekeeping during the subscription period. In the event of theft, loss, or damage due to negligence, the subscriber shall be liable to pay the full MRP of the cycle."
        }
      ]
    },
    {
      category: "Return and Cancellation",
      items: [
        {
          id: "question17",
          question: "How do I cancel my booking before it is delivered? Are there any cancellation charges?",
          answer: "Contact us to cancel your subscription within 24 hours of your booking to avoid any cancellation charges. Rs.500 will be the cancellation charges after the same."
        },
        {
          id: "question18",
          question: "I do not like the cycle on delivery. What should I do?",
          answer: "We make sure you receive the cycle as promised. If there are any technical issues in the cycle, we will exchange it with another model. The delivery cost of the same will be on us. No rejection will be accepted on the basis of looks."
        },
        {
          id: "question19",
          question: "There are some issues with the cycle. Will you refund my money?",
          answer: "All our cycles are specifically serviced & quality checked before your delivery. Check the cycle thoroughly on receiving it. Once you accept the delivery, no quality complaints will be accepted and you will be responsible for the same. Though, we will guide you with the next steps and make sure you have a good experience."
        },
        {
          id: "question20",
          question: "Can I change my cycle with a different model?",
          answer: "You can change your cycle with any available similar range model at the time. The newer price will be adjusted accordingly and you will have to pay the delivery charges."
        },
        {
          id: "question21",
          question: "I wish to return the cycle before my subscription period ends? Can I?",
          answer: "Yes, you can end your subscription anytime. In such a case, Rs.1000 will be the cancellation charges for the same. Additionally, an equivalent amount for the used duration will be charged and the rest amount refunded. (Note - subscription amount for shorter durations are comparatively higher than longer durations)"
        }
      ]
    }
  ];

  return (
    <div className="faq-container">
      <h1 className="faq-main-title">Frequently Asked Questions</h1>

      {faqData.map((section, sectionIdx) => (
        <div key={sectionIdx} className="faq-section">
          <h2 className="faq-section-title">{section.category}</h2>

          <div className="faq-list">
            {section.items.map((item) => {
              const isOpen = openQuestion === item.id;
              
              return (
                <div key={item.id} className="faq-item">
                  <button
                    onClick={() => toggleAccordion(item.id)}
                    className="faq-trigger"
                    aria-expanded={isOpen}
                  >
                    <span>{item.question}</span>
                    <span className="faq-icon">{isOpen ? '−' : '+'}</span>
                  </button>

                  <div className={`faq-answer-wrapper ${isOpen ? 'open' : ''}`}>
                    <div className="faq-answer-content">
                      {item.answer}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}